module.exports = __webpack_public_path__ + "img/historyClock.425de66b.svg";